import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  dot: { width: 12, height: 12, borderRadius: "50%", marginRight: 8 }
}));

const TicketTags = ({ ticket, compact = false }) => {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setSelectedIds((ticket.tags || []).map(tag => tag.id));
  }, [ticket.tags]);

  const openEditor = async event => {
    event.stopPropagation();
    try {
      const { data } = await api.get("/tags");
      setTags(data);
      setOpen(true);
    } catch (err) { toastError(err); }
  };

  const toggle = tagId => {
    setSelectedIds(current => current.indexOf(tagId) > -1
      ? current.filter(id => id !== tagId)
      : [...current, tagId]);
  };

  const save = async () => {
    try {
      await api.put(`/tickets/${ticket.id}/tags`, { tagIds: selectedIds });
      setOpen(false);
    } catch (err) { toastError(err); }
  };

  if (!ticket.id) return null;

  return <>
    <div className={`tw-flex tw-items-center tw-gap-1 ${compact ? "tw-shrink-0" : "tw-flex-wrap"}`} onClick={event => event.stopPropagation()}>
      {(compact ? (ticket.tags || []).slice(0, 2) : ticket.tags || []).map(tag => <Chip
        key={tag.id}
        className="tw-h-6 tw-max-w-[150px] tw-rounded-full tw-bg-messenger-pale tw-text-xs tw-text-messenger-green"
        label={tag.name}
      />)}
      <Button
        className="tw-min-w-0 tw-shrink-0 tw-rounded-full tw-border-0 tw-px-2 tw-text-xs tw-normal-case tw-text-slate-500"
        size="small"
        variant="outlined"
        startIcon={<LabelOutlinedIcon />}
        onClick={openEditor}
        aria-label={i18n.t("ticketTags.edit")}
        title={i18n.t("ticketTags.edit")}
      >
        {compact && ticket.tags?.length > 2 ? `+${ticket.tags.length - 2}` : !compact && i18n.t("ticketTags.edit")}
      </Button>
    </div>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("ticketTags.title")}</DialogTitle>
      <DialogContent dividers>
        {tags.length === 0 ? i18n.t("ticketTags.empty") : <List dense>
          {tags.map(tag => <ListItem button key={tag.id} onClick={() => toggle(tag.id)}>
            <ListItemIcon><Checkbox edge="start" checked={selectedIds.indexOf(tag.id) > -1} /></ListItemIcon>
            <span className={classes.dot} style={{ backgroundColor: tag.color }} />
            <ListItemText primary={tag.name} />
          </ListItem>)}
        </List>}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>{i18n.t("ticketTags.cancel")}</Button>
        <Button color="primary" variant="contained" onClick={save}>{i18n.t("ticketTags.save")}</Button>
      </DialogActions>
    </Dialog>
  </>;
};

export default TicketTags;
